import { render, staticRenderFns } from "./AdminControlPanel.vue?vue&type=template&id=39970e1c&scoped=true&"
import script from "./AdminControlPanel.vue?vue&type=script&lang=js&"
export * from "./AdminControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdminControlPanel.vue?vue&type=style&index=0&id=39970e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39970e1c",
  null
  
)

export default component.exports